import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchLayout } from "#modules/layouts/infra/fetchLayout.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const layoutQuery = (id: string | undefined | null) => ({
  queryKey: queryKeys.layouts.detail(id),
  queryFn: () => fetchLayout(id || ""),
  staleTime: STALE_TIME,
  enabled: !!id,
});
